module.exports = __webpack_public_path__ + "img/2_150.d2b3177b.png";